import { BaseAPI } from '@/api/base.api'
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface'
import { TipoPedido, PageTipoPedidoInput } from '@/models/tipo-pedido';

const tipoPedidoPage  = require('@/query/tipo-pedido/Page.graphql')

export class TipoPedidoAPI extends BaseAPI<TipoPedido> {
  constructor() {
    super();
    this.apiUrl = `${this.apiUrl}/api_app/v1/solicitation_types`;
  }

  public list(params: any): AxiosObservable<TipoPedido[]> {
    return this.axios.get(`${this.apiUrl}`, { params: this.buildFiltered(params) })
  }
}
